module.exports = __webpack_public_path__ + "static/media/Frame 102 (1).8df75ab1.png";